/*
 *  Product collection
 *    This Carousel worn't work well with infinite setting (wishlist icon won't show up propperly)
 *    It's better not to have Infinite setting with the wish list
 *
 *  Version:
 *    1.0.0 - 2019/16/13
 */

import $ from 'jquery';
import 'slick-carousel';

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-featured-products]';
export const CAROUSEL_SELECTOR = '[data-featured-products-carousel]';

export class FeaturedProduct extends CarouselSection {
  constructor(container) {
    super(container);

    this.container = container;
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    
    // carousel
    this.slick = this.initCarousel(this.carouselContainer);
    this.reSlick(ResponsiveSizes.small, this.carouselContainer);
  }

  optionOverrides() {
    return {
      infinite: false,
      slidesToShow: this.carouselContainer.data('slides-to-show') || 1,
      slidesToScroll: this.carouselContainer.data('slides-to-scroll') || 1,
      autoplay: this.carouselContainer.data('autoplay') == false ? false : true,
      speed: this.carouselContainer.data('slide-speed') || 500,
      dots: this.carouselContainer.data('dots') == false ? false : true,
      arrows: this.carouselContainer.data('arrows') == false ? false : true,
      adaptiveHeight: this.carouselContainer.data('adaptiveheight') == false ? false : true,
      autoplaySpeed: this.carouselContainer.data('autoplay-speed') || 5000,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 449,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: 659,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        },
        {
          breakpoint: 999,
          settings: { slidesToShow: 4, slidesToScroll: 4 }
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: "unslick"
        }
      ]
    }
  }

}

register(CONTAINER_SELECTOR, FeaturedProduct);